var _path, _linearGradient, _path2, _linearGradient2, _path3, _linearGradient3, _path4, _linearGradient4, _path5, _linearGradient5, _path6, _path7, _linearGradient6, _ellipse, _path8, _path9, _linearGradient7, _path10, _path11, _path12, _path13, _linearGradient8, _path14, _path15, _linearGradient9, _path16, _linearGradient10, _path17, _linearGradient11, _path18, _linearGradient12, _path19, _linearGradient13, _path20, _linearGradient14, _path21, _linearGradient15, _path22, _path23, _path24, _linearGradient16, _path25, _path26;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    id: "Education",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6d6287",
    d: "M50.355 30.694h1.366v7.081h-1.366z",
    className: "color627e87 svgShape"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 50.645,
    x2: 50.645,
    y1: 37.388,
    y2: 37.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#534770",
    className: "stopColor476870 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491,
    stopColor: "#574b73",
    className: "stopColor4b6b73 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791,
    stopColor: "#60557c",
    className: "stopColor55747c svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6287",
    className: "stopColor627e87 svgShape"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M50.934 31.188a.877.877 0 0 0-.48-.138h-.099v7.1h.58v-6.962z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 30.48,
    x2: 30.48,
    y1: 35.792,
    y2: 51.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#534770",
    className: "stopColor476870 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491,
    stopColor: "#574b73",
    className: "stopColor4b6b73 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791,
    stopColor: "#60557c",
    className: "stopColor55747c svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6287",
    className: "stopColor627e87 svgShape"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M43.858 45.479v-15.98c0-.933-.758-1.69-1.692-1.69H18.793c-.934 0-1.692.757-1.692 1.69v15.98h26.757z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 5.542,
    x2: 35.721,
    y1: 41.445,
    y2: 41.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#534770",
    className: "stopColor476870 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491,
    stopColor: "#574b73",
    className: "stopColor4b6b73 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791,
    stopColor: "#60557c",
    className: "stopColor55747c svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6287",
    className: "stopColor627e87 svgShape"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M29.863 42.89c0-.574-.36-1.085-.9-1.276L17.1 37.412v8.067h12.762v-2.59z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 30.48,
    x2: 30.48,
    y1: 9.571,
    y2: 42.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#534770",
    className: "stopColor476870 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#574b74",
    className: "stopColor4b6c74 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#63587f",
    className: "stopColor58767f svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6287",
    className: "stopColor627e87 svgShape"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M54.376 30.43 30.78 38.794a.935.935 0 0 1-.615 0L6.582 30.425c-.596-.212-.596-.885 0-1.097l23.598-8.364c.196-.07.42-.07.615 0l23.581 8.37c.597.211.597.885 0 1.096z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 30.48,
    x2: 30.48,
    y1: 48.037,
    y2: 45.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#534770",
    className: "stopColor476870 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#574b74",
    className: "stopColor4b6c74 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#63587f",
    className: "stopColor58767f svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6287",
    className: "stopColor627e87 svgShape"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "m54.373 30.426-23.59 8.371a.96.96 0 0 1-.623 0l-23.579-8.37c-.534-.198-.584-.753-.168-1.01l23.935 8.49c.08.03.168.03.248 0l23.945-8.48c.425.257.376.811-.168 1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#8e5fff",
    d: "M51.052 36.644a1.237 1.237 0 0 0-1.25 1.244v4.355a.109.109 0 0 0 .218 0v-3.859c.06.13.148.244.252.33v3.529a.109.109 0 0 0 .218 0v-3.371c.06.034.122.07.183.087v3.284a.109.109 0 0 0 .217 0v-3.24c.044.016.096.016.148.016s.105 0 .148-.017v3.24a.109.109 0 0 0 .218 0V38.96a.877.877 0 0 0 .183-.087v3.37a.109.109 0 0 0 .217 0v-3.527a.955.955 0 0 0 .253-.33v3.858a.109.109 0 0 0 .217 0v-4.341c0-.681-.54-1.251-1.222-1.258z",
    className: "colorffe05f svgShape"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 30.48,
    x2: 30.48,
    y1: 45.501,
    y2: 48.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#534770",
    className: "stopColor476870 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491,
    stopColor: "#574b73",
    className: "stopColor4b6b73 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791,
    stopColor: "#60557c",
    className: "stopColor55747c svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6287",
    className: "stopColor627e87 svgShape"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.48,
    cy: 29.879,
    fill: "url(#f)",
    rx: 1.431,
    ry: 0.825
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#6d31ff",
    d: "M41.405 53.09v9.438H5.719C3.12 62.528 1 60.408 1 57.81a4.723 4.723 0 0 1 4.72-4.719h35.685z",
    className: "color31bfff svgShape"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M63.79 53.93H35.867a3.877 3.877 0 0 0 0 7.753h27.925c-.334-2.7-.367-5.295 0-7.754z",
    className: "colorefefef svgShape"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 47.892,
    x2: 47.892,
    y1: 62.848,
    y2: 50.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef",
    className: "stopColorefefef svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#e4e4e4",
    className: "stopColore4e4e4 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0e0e0",
    className: "stopColore0e0e0 svgShape"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M63.584 55.876H35.87a3.866 3.866 0 0 0-3.75 2.909 3.545 3.545 0 0 1-.128-.98 3.879 3.879 0 0 1 3.879-3.879h27.922a21.352 21.352 0 0 0-.208 1.95z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#8a5aff",
    d: "M64.159 60.842H35.953c-1.448 0-2.767-.98-3.057-2.398a3.041 3.041 0 0 1 2.97-3.674h28.293a.841.841 0 0 0 0-1.682H36.076c-2.463 0-4.666 1.796-4.905 4.247a4.723 4.723 0 0 0 4.695 5.19h28.293a.841.841 0 1 0 0-1.682z",
    className: "color5ae0ff svgShape"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#48259d",
    d: "M37.58 43.65v9.438H9.383c-2.6 0-4.72-2.12-4.72-4.719a4.723 4.723 0 0 1 4.72-4.719H37.58z",
    className: "color7d51c6 svgShape"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M55.054 44.49H32.041a3.877 3.877 0 1 0 0 7.753h23.013c-.334-2.7-.367-5.295 0-7.754z",
    className: "colorefefef svgShape"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 41.608,
    x2: 41.608,
    y1: 52.273,
    y2: 40.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef",
    className: "stopColorefefef svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#e4e4e4",
    className: "stopColore4e4e4 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0e0e0",
    className: "stopColore0e0e0 svgShape"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M55.055 44.487a21.13 21.13 0 0 0-.207 2.107H32.04a3.87 3.87 0 0 0-3.73 2.82 3.63 3.63 0 0 1-.148-1.049 3.885 3.885 0 0 1 3.878-3.878h23.015z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#8e6fd8",
    d: "M55.422 51.402H32.128c-1.448 0-2.767-.98-3.057-2.398a3.041 3.041 0 0 1 2.97-3.674h23.381a.841.841 0 1 0 0-1.682h-23.17c-2.464 0-4.667 1.796-4.906 4.247a4.723 4.723 0 0 0 4.695 5.19h23.381a.841.841 0 1 0 0-1.682z",
    className: "color906fd8 svgShape"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 26.837,
    x2: 59.881,
    y1: 47.418,
    y2: 47.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0e0e0",
    className: "stopColore0e0e0 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#e4e4e4",
    className: "stopColore4e4e4 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efefef",
    className: "stopColorefefef svgShape"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M52.285 47.191H33.03a.216.216 0 0 0-.216.216v.022c0 .12.096.216.216.216h19.254c.12 0 .216-.097.216-.216v-.022a.216.216 0 0 0-.216-.216z"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 26.837,
    x2: 59.881,
    y1: 48.596,
    y2: 48.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0e0e0",
    className: "stopColore0e0e0 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#e4e4e4",
    className: "stopColore4e4e4 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efefef",
    className: "stopColorefefef svgShape"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M52.285 48.369H33.03a.216.216 0 0 0-.216.216v.021c0 .12.096.216.216.216h19.254c.12 0 .216-.096.216-.216v-.02a.216.216 0 0 0-.216-.217z"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 26.837,
    x2: 59.881,
    y1: 49.773,
    y2: 49.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0e0e0",
    className: "stopColore0e0e0 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#e4e4e4",
    className: "stopColore4e4e4 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efefef",
    className: "stopColorefefef svgShape"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M52.285 49.547H33.03a.216.216 0 0 0-.216.216v.021c0 .12.096.216.216.216h19.254c.12 0 .216-.097.216-.216v-.021a.216.216 0 0 0-.216-.216z"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 36.989,
    x2: 61.296,
    y1: 56.858,
    y2: 56.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0e0e0",
    className: "stopColore0e0e0 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#e4e4e4",
    className: "stopColore4e4e4 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efefef",
    className: "stopColorefefef svgShape"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M61.08 56.631H37.205a.216.216 0 0 0-.216.216v.022c0 .12.097.216.216.216H61.08c.119 0 .216-.097.216-.216v-.022a.216.216 0 0 0-.216-.216z"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 36.989,
    x2: 61.296,
    y1: 58.036,
    y2: 58.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0e0e0",
    className: "stopColore0e0e0 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#e4e4e4",
    className: "stopColore4e4e4 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efefef",
    className: "stopColorefefef svgShape"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M61.08 57.81H37.205a.216.216 0 0 0-.216.215v.021c0 .12.097.217.216.217H61.08c.119 0 .216-.097.216-.217v-.02a.216.216 0 0 0-.216-.217z"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 36.989,
    x2: 61.296,
    y1: 59.214,
    y2: 59.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0e0e0",
    className: "stopColore0e0e0 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#e4e4e4",
    className: "stopColore4e4e4 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efefef",
    className: "stopColorefefef svgShape"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M61.08 58.987H37.205a.216.216 0 0 0-.216.216v.021c0 .12.097.216.216.216H61.08c.119 0 .216-.097.216-.216v-.021a.216.216 0 0 0-.216-.216z"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 46.102,
    x2: 58.962,
    y1: 15.96,
    y2: 15.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5915ff",
    className: "stopColor15a0ff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#5c19ff",
    className: "stopColor19a4ff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#6526ff",
    className: "stopColor26b0ff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#753cff",
    className: "stopColor3cc4ff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a5aff",
    className: "stopColor5ae0ff svgShape"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M46.102 15.767a6.437 6.437 0 0 0 6.436 6.435c.853 0 1.671-.17 2.41-.478l3.616.865-.75-3.15a6.398 6.398 0 0 0 1.148-3.672 6.427 6.427 0 0 0-6.424-6.436 6.43 6.43 0 0 0-6.436 6.436z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#5915ff",
    d: "M57.158 11.858c0-.2-.018-.395-.03-.591a6.43 6.43 0 0 0-11.026 4.5c0 2.473 1.401 4.623 3.454 5.7 4.352-1.035 7.602-4.945 7.602-9.61z",
    className: "color15a0ff svgShape"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#6f33ff",
    d: "M55.658 11.858c0 4.622-3.748 8.385-8.386 8.385a8.19 8.19 0 0 1-3.14-.622l-4.712 1.126.978-4.104a8.337 8.337 0 0 1-1.497-4.785c0-4.638 3.749-8.386 8.371-8.386a8.378 8.378 0 0 1 8.386 8.386z",
    className: "colorffc933 svgShape"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 73.463,
    x2: 37.338,
    y1: 44.517,
    y2: 3.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8e5fff",
    className: "stopColorffe05f svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#824eff",
    className: "stopColorffd24e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#7238ff",
    className: "stopColorffc038 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#692bff",
    className: "stopColorffb52b svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6627ff",
    className: "stopColorffb127 svgShape"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M55.658 11.858c0 4.622-3.748 8.385-8.386 8.385a8.19 8.19 0 0 1-3.14-.622l-4.712 1.126.978-4.104a8.337 8.337 0 0 1-1.497-4.785c0-.8.104-1.57.326-2.297-.014.06-.014.104-.014.163 0 4.015 3.244 7.275 7.26 7.275a7.278 7.278 0 0 0 7.274-7.275 7.156 7.156 0 0 0-1.896-4.874 8.308 8.308 0 0 1 3.807 7.008z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M51.297 13.918c0 .261-.209.47-.47.47h-7.089c-.26 0-.469-.209-.469-.47s.208-.469.47-.469h7.089c.26 0 .469.209.469.47zM43.269 9.8c0-.26.208-.469.47-.469h7.089c.26 0 .469.208.469.47a.464.464 0 0 1-.47.451h-7.089a.464.464 0 0 1-.469-.452zm9.696 2.05c0 .261-.209.47-.452.47h-10.46a.467.467 0 0 1-.47-.47c0-.243.21-.451.47-.451h10.46a.46.46 0 0 1 .452.452z",
    className: "colorffffff svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24);
export default __webpack_public_path__ + "static/media/24.2ac9065eae99c329a11ad2e8129ede10.svg";
export { ForwardRef as ReactComponent };